/* ==========================================================================
   Options on product cards

   Products with options (Small / Large, a filling, how many pieces) can be
   chosen and added to the cart straight from any product card, instead of
   opening the product page to choose.

   Two kinds of card exist on the site, and both are handled:

   - GemPages cards (<gp-product>, the collection pages built in GemPages).
     These already have an Add to cart button, which until now always added
     the first option. The picker tells the card which option is chosen via
     GemPages' own setContext('variantSelected'), and GemPages then updates
     the card's price and adds that option. Nothing in GemPages' generated
     code is edited, so republishing from GemPages cannot undo this.

   - Theme cards (.product-card-wrapper: the standard collection grid, search,
     related products). These had no button at all, so they get the picker and
     an Add to cart button that adds through the theme's own cart pop-up.

   A GemPages card that already carries GemPages' own variant picker (the main
   product on a product page) is left alone.

   Turned on and off in the theme editor: Theme settings > Sammy's design >
   "Choose options on product cards". Off means this file is never loaded.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__sammysCardOptions) return;
  window.__sammysCardOptions = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  var STR = window.variantStrings || {};
  var TEXT = {
    add: STR.addToCart || 'Add to cart',
    soldOut: STR.soldOut || 'Sold out',
    unavailable: STR.unavailable || 'Unavailable',
    adding: 'Adding…',
    added: 'Added',
    choose: 'Choose options'
  };

  /* Pills while an option is short enough to scan at a glance; a dropdown
     once it would wrap into a wall (14 pizza toppings, say). */
  var PILL_MAX_VALUES = 4;
  var PILL_MAX_CHARS = 16;

  var money = (function () {
    var f;
    try { f = new Intl.NumberFormat('en-AU', { style: 'currency', currency: CURRENCY }); } catch (e) { f = null; }
    return function (cents) {
      var n = Number(cents) / 100;
      return f ? f.format(n) : '$' + n.toFixed(2);
    };
  })();

  var uid = 0;

  /* ---- product data ------------------------------------------------------ */

  var products = {};
  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return products[handle];
  }

  function handleOf(href) {
    try {
      var m = new URL(href, location.href).pathname.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  /* Options that are real choices. A single-variant product reports one
     option, "Title", with the value "Default Title". */
  function realOptions(p) {
    return (p.options || []).filter(function (o) {
      return !(o.values.length === 1 && /^default title$/i.test(o.values[0]));
    });
  }

  function findVariant(p, chosen) {
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var ok = true;
      for (var k = 0; k < chosen.length; k++) {
        if (chosen[k] != null && v.options[k] !== chosen[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Is there anything in stock with this value, keeping the other choices? */
  function valueAvailable(p, chosen, pos, value) {
    var probe = chosen.slice();
    probe[pos] = value;
    var v = findVariant(p, probe);
    return !!(v && v.available);
  }

  /* Choosing a value that has no match with the other choices moves the
     other choices to the nearest real, preferably in-stock, combination. */
  function settle(p, chosen, pos) {
    var exact = findVariant(p, chosen);
    if (exact) return exact;
    var keep = chosen[pos];
    var best = null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (v.options[pos] !== keep) continue;
      if (v.available) return v;
      if (!best) best = v;
    }
    return best || p.variants[0];
  }

  /* ---- the picker -------------------------------------------------------- */

  function h(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }

  function buildPicker(p, start, onChange) {
    var opts = realOptions(p);
    var positions = opts.map(function (o) { return o.position - 1; });
    var chosen = start.options.slice();
    var box = h('div', 'sq');
    var groups = [];
    var id = 'sq' + (++uid);

    opts.forEach(function (o, n) {
      var pos = positions[n];
      // window.sqSelectsOnly (set by the At Home grid, SCBB-T8) shows every option as a dropdown
      var pills = !window.sqSelectsOnly && o.values.length <= PILL_MAX_VALUES &&
        o.values.every(function (v) { return String(v).length <= PILL_MAX_CHARS; });

      if (pills) {
        var fs = h('fieldset', 'sq__opt');
        fs.appendChild(h('legend', 'sq__label', o.name));
        var row = h('div', 'sq__pills');
        o.values.forEach(function (val) {
          var lab = h('label', 'sq__pill');
          var input = h('input');
          input.type = 'radio';
          input.name = id + '-' + pos;
          input.value = val;
          input.addEventListener('change', function () { pick(pos, val); });
          lab.appendChild(input);
          lab.appendChild(h('span', null, val));
          row.appendChild(lab);
        });
        fs.appendChild(row);
        box.appendChild(fs);
        groups.push({ pos: pos, type: 'pills', el: row, values: o.values });
      } else {
        var wrap = h('label', 'sq__opt');
        wrap.appendChild(h('span', 'sq__label', o.name));
        var sel = h('select', 'sq__select');
        o.values.forEach(function (val) {
          var op = h('option', null, val);
          op.value = val;
          sel.appendChild(op);
        });
        sel.addEventListener('change', function () { pick(pos, sel.value); });
        wrap.appendChild(sel);
        box.appendChild(wrap);
        groups.push({ pos: pos, type: 'select', el: sel, values: o.values });
      }
    });

    function paint() {
      groups.forEach(function (g) {
        if (g.type === 'pills') {
          Array.prototype.forEach.call(g.el.querySelectorAll('input'), function (input) {
            input.checked = input.value === chosen[g.pos];
            input.parentNode.classList.toggle('is-na', !valueAvailable(p, chosen, g.pos, input.value));
          });
        } else {
          g.el.value = chosen[g.pos];
          Array.prototype.forEach.call(g.el.options, function (op) {
            var ok = valueAvailable(p, chosen, g.pos, op.value);
            op.textContent = op.value + (ok ? '' : ' — ' + TEXT.soldOut.toLowerCase());
          });
        }
      });
    }

    function pick(pos, val) {
      chosen[pos] = val;
      var v = settle(p, chosen, pos);
      chosen = v.options.slice();
      paint();
      onChange(v);
    }

    paint();
    return box;
  }

  /* Stop a tap on the picker from also following the card's link. */
  function contain(el) {
    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      el.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
    });
  }

  /* ---- GemPages cards ---------------------------------------------------- */

  function initGemPages(card, p) {
    if (realOptions(p).length === 0 || p.variants.length < 2) return;

    var current = null;
    try { current = card.getContext && card.getContext('variantSelected'); } catch (e) { current = null; }
    var start = (current && p.variants.filter(function (v) { return v.id === current.id; })[0]) ||
      p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];

    var picker = buildPicker(p, start, function (v) {
      try { card.setContext('variantSelected', v); } catch (e) { /* GemPages API changed; the card keeps working as before */ }
    });
    picker.classList.add('sq--gp');
    contain(picker);

    var btn = card.querySelector('gp-product-button');
    btn.parentNode.insertBefore(picker, btn);

    /* The card's own button colour is the selected pill's colour, so the
       picker belongs to whichever design the card has. */
    var face = btn.querySelector('button, .gp-button, a') || btn;
    var bg = getComputedStyle(face).backgroundColor;
    if (bg && !/rgba\(0, 0, 0, 0\)|transparent/.test(bg)) picker.style.setProperty('--sq-accent', bg);

    if (start.id !== (current && current.id)) {
      try { card.setContext('variantSelected', start); } catch (e) { /* as above */ }
    }
  }

  /* ---- theme cards ------------------------------------------------------- */

  function cartTarget() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setThemePrice(card, v) {
    var box = card.querySelector('.price');
    if (!box) return;
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    box.classList.toggle('price--on-sale', !!sale);
    box.classList.toggle('price--sold-out', !v.available);
    var regular = box.querySelector('.price__regular .price-item--regular');
    if (regular) regular.textContent = money(v.price);
    var saleNow = box.querySelector('.price__sale .price-item--sale');
    if (saleNow) saleNow.textContent = money(v.price);
    var was = box.querySelector('.price__sale s.price-item--regular');
    if (was) was.textContent = sale ? money(v.compare_at_price) : '';
  }

  function initTheme(card, p) {
    var content = card.querySelector('.card > .card__content') || card.querySelector('.card__content');
    if (!content) return;

    var hasChoices = realOptions(p).length > 0 && p.variants.length > 1;

    // window.sqMaxInline (set by the At Home grid, SCBB-T8): products with more option groups than this
    // show a "Choose options" link to the product page instead of every dropdown, so cards stay compact.
    if (window.sqMaxInline && hasChoices && realOptions(p).length > window.sqMaxInline) {
      var morePanel = h('div', 'sq sq--theme sq--more');
      contain(morePanel);
      var more = h('a', 'sq__add button button--full-width', TEXT.choose);
      var link = card.querySelector('.card__heading a[href*="/products/"]');
      more.href = link ? link.href : ROOT + 'products/' + p.handle;
      morePanel.appendChild(more);
      content.appendChild(morePanel);
      return;
    }
    var start = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var variant = start;

    var panel = h('div', 'sq sq--theme');
    contain(panel);

    var status = h('p', 'sq__status');
    status.setAttribute('role', 'status');

    var add = h('button', 'sq__add button button--full-width', TEXT.add);
    add.type = 'button';

    function sync(v) {
      variant = v;
      setThemePrice(card, v);
      add.disabled = !v.available;
      add.textContent = v.available ? TEXT.add : TEXT.soldOut;
      status.textContent = '';
    }

    if (hasChoices) {
      var picker = buildPicker(p, start, sync);
      while (picker.firstChild) panel.appendChild(picker.firstChild);
    }

    add.addEventListener('click', function () {
      if (!variant || !variant.available || add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      add.textContent = TEXT.adding;
      status.textContent = '';

      var cart = cartTarget();
      var body = new FormData();
      body.append('id', variant.id);
      body.append('quantity', (variant.quantity_rule && variant.quantity_rule.min) || 1);
      if (cart && cart.getSectionsToRender) {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', location.pathname);
      }

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
          add.textContent = TEXT.added;
          if (cart && cart.renderContents) {
            if (cart.setActiveElement) cart.setActiveElement(add);
            cart.renderContents(res);
          } else {
            location.href = ROOT + 'cart';
          }
          setTimeout(function () { sync(variant); }, 1400);
        })
        .catch(function (err) {
          status.textContent = err.message;
          add.textContent = TEXT.add;
        })
        .then(function () { add.removeAttribute('aria-busy'); });
    });

    panel.appendChild(add);
    panel.appendChild(status);
    content.appendChild(panel);
    sync(start);
  }

  /* ---- finding cards ----------------------------------------------------- */

  function candidates(scope) {
    var found = [];

    Array.prototype.forEach.call(scope.querySelectorAll('gp-product'), function (el) {
      if (el.hasAttribute('data-sq')) return;
      if (!el.querySelector('gp-product-button')) return;
      if (el.querySelector('gp-product-variants')) return;     // GemPages' own picker is there
      var a = el.querySelector('a[href*="/products/"]');
      var handle = a && handleOf(a.href);
      if (!handle) return;
      el.setAttribute('data-sq', '');
      found.push({ el: el, handle: handle, kind: 'gp' });
    });

    Array.prototype.forEach.call(scope.querySelectorAll('.product-card-wrapper'), function (el) {
      if (el.hasAttribute('data-sq')) return;
      if (el.querySelector('.quick-add, .sq')) return;       // the theme's own quick add is on
      var a = el.querySelector('.card__heading a[href*="/products/"]') || el.querySelector('a[href*="/products/"]');
      var handle = a && handleOf(a.href);
      if (!handle) return;
      el.setAttribute('data-sq', '');
      found.push({ el: el, handle: handle, kind: 'theme' });
    });

    return found;
  }

  function start(item) {
    getProduct(item.handle).then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      if (p.requires_selling_plan) return;
      if (item.kind === 'gp') initGemPages(item.el, p);
      else initTheme(item.el, p);
    }).catch(function () { /* leave the card as it was */ });
  }

  /* Cards are wired as they come near the screen, so a long collection does
     not fetch every product up front. */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        start(e.target.__sq);
      });
    }, { rootMargin: '600px 0px' })
    : null;

  function scan(scope) {
    candidates(scope || document).forEach(function (item) {
      if (io) { item.el.__sq = item; io.observe(item.el); } else start(item);
    });
  }

  function boot() {
    scan(document);
    /* Filtering, sorting and "load more" swap cards in after load. */
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(document); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
